import { Structure } from "../models/structure";

export class FilterStructuresWithoutDevicesValueConverter {
	toView(array: Array<Structure>): Array<Structure> {

		if (array === undefined || array === null) {
			return null;
		}
		const filtered = array.filter((item) => item.devices && item.devices.length > 0);
		return filtered.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
		
	}
}

